import React from "react";

const REASON_LABELS = {
  hire: "Hire VBB",
  pitch: "Pitch a project",
  partner: "Partner / collab",
  hi: "Just say hi",
};

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function ContactDetail({ contact, onDelete }) {
  if (!contact) {
    return (
      <div
        className="lg:col-span-7 p-8 lg:p-10 min-h-[320px]"
        data-testid="admin-inbox-detail"
      >
        <div className="font-mono-tiny text-[#6b6b6b]">
          Select a submission to read it here.
        </div>
      </div>
    );
  }
  return (
    <div
      className="lg:col-span-7 p-8 lg:p-10 min-h-[320px]"
      data-testid="admin-inbox-detail"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="font-mono-tiny text-[#6b6b6b]">
            {formatDate(contact.created_at)}
          </div>
          <h2
            className="font-display text-3xl sm:text-4xl mt-2 uppercase tracking-tight"
            data-testid="admin-detail-name"
          >
            {contact.name}
          </h2>
          <div className="mt-2 text-[14px] text-[#3a3a3a] flex items-center gap-3 flex-wrap">
            <a
              href={`mailto:${contact.email}`}
              className="vbb-link"
              data-testid="admin-detail-mailto"
            >
              {contact.email}
            </a>
            {contact.reason && REASON_LABELS[contact.reason] && (
              <span
                className="font-mono-tiny px-2 py-1 border border-[#0a0a0a]"
                data-testid="admin-detail-reason"
              >
                {REASON_LABELS[contact.reason]}
              </span>
            )}
            {contact.company ? <span>· {contact.company}</span> : null}
          </div>
        </div>
        <button
          onClick={() => onDelete(contact.id)}
          className="vbb-btn vbb-btn-ghost !py-2 !px-3 !text-[11px]"
          data-testid="admin-detail-delete-btn"
        >
          Delete
        </button>
      </div>

      <div className="vbb-border-t mt-8 pt-6">
        <div className="font-mono-tiny text-[#6b6b6b] mb-3">Message</div>
        <p
          className="text-[16px] leading-relaxed text-[#0a0a0a] whitespace-pre-wrap"
          data-testid="admin-detail-message"
        >
          {contact.message}
        </p>
      </div>

      <div className="vbb-border-t mt-10 pt-6 flex flex-wrap gap-3">
        <a
          href={`mailto:${contact.email}?subject=Re:%20your%20note%20to%20Very%20Big%20Box`}
          className="vbb-btn"
          data-testid="admin-detail-reply-btn"
        >
          Reply by email →
        </a>
      </div>
    </div>
  );
}
